module.exports = __webpack_public_path__ + "img/arrow-right.5deadd98.svg";